/************************************** THIRD-PARTY MODULES ***************************************/
import {observable} from 'mobx';

/**************************************** PROJECT MODULES *****************************************/
import {RootStore} from '../root-store';
import {storeLocally, Serializable} from '../../hocs/serialization';

const filename = 'home-screen-ui-store.ts';

// prettier-ignore
/**************************************** INJECTED SETTERS ****************************************/
/**
 * Methods automatically set by @Serializable
 */
abstract class HomeScreenUIStoreSetters {
    setPendingClinicEntryId:              (pendingClinicEntryId: string | undefined)   => void;
    setIsMyRecordsCollapsed:              (isMyRecordsCollapsed: boolean)              => void;
    setIsLearnAboutImmunizationCollapsed: (isLearnAboutImmunizationCollapsed: boolean) => void;
    setIsPopularTopicsCollapsed:          (isPopularTopicsCollapsed: boolean)          => void;
}

/********************************************* EXPORT *********************************************/
/**
 * Singleton store for Home screen UI state data (post-login)
 * @singleton
 */
@Serializable({
    filename,
    isSingleton: true,
})
export class HomeScreenUIStore extends HomeScreenUIStoreSetters {
    public static Instance: HomeScreenUIStore | null = null;

    /***** Data props *****/
    @storeLocally
    @observable
    pendingClinicEntryId: string | undefined = undefined;

    @storeLocally
    @observable
    isMyRecordsCollapsed = false;

    @storeLocally
    @observable
    isLearnAboutImmunizationCollapsed = false;

    @storeLocally
    @observable
    isPopularTopicsCollapsed = false;

    /***** Initialization *****/
    /**
     * Build singleton store for (post-login) Home screen UI
     */
    public constructor(public rootStore: RootStore) {
        super();
        HomeScreenUIStore.Instance = HomeScreenUIStore.Instance || this;
        return HomeScreenUIStore.Instance;
    }
}
